import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Switch from "./components/Switch";
import SwitchSettings from "./components/SwitchSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/switch_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'switch',
    group: ElementGroup.SELECT,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_SWITCH'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        defaultChecked: false,
        disabled: false,
        autoFocus: false,
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_SWITCH'],
      },
      settings: {
        width: {
          value: 'auto',
        },
      },
    },
    pluginComponent: Switch, // 插件渲染组件
    pluginSettingComponent: SwitchSettings, // 插件设置项组件
  }
}
